import util from '@bmp-vue/core/api/util'

const controller = 'CredenciaisAsigni'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetByPortal: function (codigoPortal) {
    return util.Axios.Get(controller + '/GetByPortal', codigoPortal)
  }
})
